export const isLoaderShown = (state) => state.loader.isLoaderShown;
